<section class="navbar">
  <div class="navbar-container w-container">
    <div class="nav-content">
      <div class="nav-menu">
        <a href="/{{translate.currentLang}}" class="navbar-logo w-inline-block">
          <img class="logo object-fit-contain" src="/assets/img/seoHeaderImg/LF_logo-horizontal.webp" loading="lazy" alt="Logo Livinfrance" width="250" height="50">
        </a>
        <div class="nav-links desktop">
          <div class="nav-links desktop">
            <a rel="nofollow" (click)="goToLink(translate.currentLang +'/housing-certificate/start','')"  class="nav-link w-inline-block overflow-hidden text-nowrap pointer">
              <div [ngClass]="{'me-2': translate.currentLang == 'fr'}">{{"LANDING_2.SEO_HEADER.HOUSINGCERTIFICATE" | translate }}</div>
            </a>
            <div data-hover="false" data-delay="0" class="nav-dropdown w-dropdown" [ngClass]="isopened == 'housing' ? 'w--open' : ''">
              <div class="nav-link w-dropdown-toggle" (click)="toggleIsOpened('housing')">
                <div>{{"LANDING_2.SEO_HEADER.HOUSING" | translate }}</div><img src="/assets/img/seoHeaderImg/chevron-down-outline-5.svg" loading="lazy" alt="chevron-down" class="dropdown-icon">
              </div>
              <nav class="dropdown-list w-dropdown-list" [ngClass]="isopened == 'housing' ? 'w--open' : ''">
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/lille','')" class="dropdown-link w-inline-block">
                  <div>Lille</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/toulouse','')"  class="dropdown-link w-inline-block">
                  <div>Toulouse</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/nantes','')"  class="dropdown-link w-inline-block">
                  <div>Nantes</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/lyon','')"  class="dropdown-link w-inline-block">
                  <div>Lyon</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/reims','')"  class="dropdown-link w-inline-block">
                  <div>Reims</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/nancy','')"  class="dropdown-link w-inline-block">
                  <div>Nancy</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/paris','')"  class="dropdown-link w-inline-block">
                  <div>Paris</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/bordeaux','')"  class="dropdown-link w-inline-block">
                  <div>Bordeaux</div>
                </a>
                <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list','')" class="seeall-dropdown-link w-inline-block">
                  <div>{{"LANDING_2.SEO_HEADER.ALLCITIES" | translate }}</div>
                  <img src="/assets/img/seoHeaderImg/chevron-forward-outline-5-1.svg" loading="lazy" alt="chevron-forward" class="image-25" />
                </a>
              </nav>
            </div>
            <a class="nav-link w-inline-block" [href]="translate.currentLang == 'fr' ? ['/fr/bourse'] : ['/en/bourse']">
              <div>{{"LANDING_2.SEO_FOOTER.SCHOLARSHIP" | translate }}</div>
            </a>
            <a class="nav-link w-inline-block" [href]="translate.currentLang == 'fr' ? ['/fr/blog'] : ['/en/blog']">
              <div>{{"LANDING_2.SEO_HEADER.BLOG" | translate }}</div>
            </a>
          </div>

        </div>
      </div>
      <div class="navbar-content">
        <a [routerLink]="['/'+ translate.currentLang +'/livinfrance/login']" class="navbar-button btn-lf-primary nomob w-inline-block">
          <div>{{"LANDING_2.SEO_HEADER.CONNECT" | translate }}</div>
        </a>
        <div class="language-select nomob">
          <button (click)="useLanguage('en');flagToggle('en')" [ngClass]="grey == 'en' ?'bgGrey':'' " class="link-block-27 w-inline-block"><img src="./assets/img/seoHeaderImg/flag_en.webp" loading="lazy" alt="lang-en" class="image-60"></button>
          <button (click)="useLanguage('fr');flagToggle('fr')" [ngClass]="grey == 'fr' ?'bgGrey':''" class="link-block-27 w-inline-block"><img src="/assets/img/seoHeaderImg/flag_fr.webp" loading="lazy" alt="lang-fr" class="image-60"></button>
        </div>
        <div data-hover="false" data-delay="0" class="navbar-dropdown mobile w-dropdown" [ngClass]="burgerOpened ? 'w--open' : ''">
          <div class="nav-dropdwon-toggle w-dropdown-toggle" (click)="fBurgerOpened()">
            <img src="/assets/img/seoHeaderImg/menu-outline-2-1.svg" loading="lazy" alt="menu-open" class="image-62">
          </div>
          <nav class="navbar-dropdown-list w-dropdown-list" [ngClass]="burgerOpened ? 'w--open' : ''">
            <div class="dropdown-list-wrapper">
              <div class="navbar-list-item">
                <div class="nav-header">
                  <div class="menu-heading">{{"LANDING_2.SEO_HEADER.HEYTHERE"| translate }}</div>
                  <img src="/assets/img/seoHeaderImg/wave-2.webp" loading="lazy" alt="menu-wave" class="image-67">
                </div>
                <div class="dropdown-register">
                  <a [routerLink]="['/'+ translate.currentLang +'/livinfrance/login']" class="navbar-button btn-lf-primary w-inline-block">
                    <img src="/assets/img/seoHeaderImg/person-circle-outline-1-1.webp" loading="lazy" alt="menu-person" class="image-66">
                    <div>{{"LANDING_2.SEO_HEADER.REGISTER"| translate }}</div>
                  </a>
                  <a [routerLink]="['/'+ translate.currentLang +'/livinfrance/login']" class="navbar-button2 btn-lf-secondary w-inline-block">
                    <img src="/assets/img/seoHeaderImg/log-in-outline-1.webp" loading="lazy" alt="menu-login" class="image-66">
                    <div class="text-block">{{"LANDING_2.SEO_HEADER.CONNECT" | translate }}</div>
                  </a>
                </div>
              </div>
              <div class="nav-links">
                <div class="menu-heading">Menu</div>
                <div class="navbar-item w-node">
                  <div data-hover="false" data-delay="0" class="nav-dropdown w-dropdown">
                    <a class="nav-link w-inline-block" [href]="translate.currentLang == 'fr' ? ['/fr/blog'] : ['/en/blog']">
                      <div>{{"LANDING_2.SEO_HEADER.BLOG" | translate }}</div>
                    </a>
                  </div>
                </div>
                <div class="navbar-item w-node">
                  <div data-hover="false" data-delay="0" class="nav-dropdown w-dropdown">
                    <a class="nav-link w-inline-block" [href]="translate.currentLang == 'fr' ? ['/fr/bourse'] : ['/en/bourse']">
                      <div>{{"LANDING_2.SEO_HEADER.SCHOLARSHIP" | translate }}</div>
                    </a>
                  </div>
                </div>
                <div class="navbar-item w-node">
                  <div data-hover="false" data-delay="0" class="nav-dropdown w-dropdown">
                    <a rel="nofollow" (click)="goToLink(translate.currentLang +'/housing-certificate/start','')" class="nav-link w-inline-block">
                      <img src="/assets/img/seoHeaderImg/earth-outline-3.svg" loading="lazy" alt="menu-heart" class="image-65">
                      <div>{{"LANDING_2.SEO_HEADER.HOUSINGCERTIFICATE" | translate }}</div>
                    </a>
                  </div>
                </div>
                <div class="navbar-item w-node">
                  <div data-hover="false" data-delay="0" class="nav-dropdown w-dropdown" [ngClass]="isopened == 'housingResponsive' ? 'w--open' : ''">
                    <div class="nav-link w-dropdown-toggle" (click)="toggleIsOpened('housingResponsive')">
                      <img src="/assets/img/seoHeaderImg/home-outline-9.svg" loading="lazy" alt="menu-home" class="image-65">
                      <div>{{"LANDING_2.SEO_HEADER.HOUSING" | translate }}</div>
                      <img src="/assets/img/seoHeaderImg/chevron-down-outline-5.svg" loading="lazy" alt="chevron-down" class="dropdown-icon">
                    </div>
                    <nav class="dropdown-list w-dropdown-list"  [ngClass]="isopened == 'housingResponsive' ? 'w--open' : ''">
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/lille','')" class="dropdown-link w-inline-block">
                        <div>Lille</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/toulouse','')" class="dropdown-link w-inline-block">
                        <div>Toulouse</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/nantes','')" class="dropdown-link w-inline-block">
                        <div>Nantes</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/lyon','')" class="dropdown-link w-inline-block">
                        <div>Lyon</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/reims','')" class="dropdown-link w-inline-block">
                        <div>Reims</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/nancy','')" class="dropdown-link w-inline-block">
                        <div>Nancy</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/paris','')" class="dropdown-link w-inline-block">
                        <div>Paris</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list/bordeaux','')" class="dropdown-link w-inline-block">
                        <div>Bordeaux</div>
                      </a>
                      <a rel="nofollow" (click)="goToLink(translate.currentLang + '/accommodation/list','')" class="seeall-dropdown-link w-inline-block">
                        <div>{{"LANDING_2.SEO_HEADER.ALLCITIES" | translate }}</div>
                        <img src="/assets/img/seoHeaderImg/chevron-forward-outline-5-1.svg" loading="lazy" alt="chevron-forward" class="image-25">
                      </a>
                    </nav>
                  </div>
                </div>
                <a href="/{{translate.currentLang}}/livinfrance/login" class="navbar-button nomob w-inline-block">
                  <div>{{"LANDING_2.SEO_HEADER.CONNECT" | translate }}</div>
                </a>
              </div>
              <div class="navbar-list-item">
                <div class="language-select">
                  <button (click)="useLanguage('en');flagToggle('en')" [ngClass]="grey == 'en' ?'bgGrey':''" class=" link-block-27 w-inline-block">
                    <img src="./assets/img/seoHeaderImg/flag_en.webp" loading="lazy" alt="lang-en" class="image-60"></button>
                  <button (click)="useLanguage('fr');flagToggle('fr')" [ngClass]="grey == 'fr' ?'bgGrey':''" class="link-block-27 w-inline-block">
                    <img src="./assets/img/seoHeaderImg/flag_fr.webp" loading="lazy" alt="lang-fr" class="image-60"></button>
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>
